import { render, staticRenderFns } from "./gigya-initializer.vue?vue&type=template&id=105b3efc&scoped=true"
import script from "./gigya-initializer.vue?vue&type=script&lang=js"
export * from "./gigya-initializer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b3efc",
  null
  
)

export default component.exports